<template>
  <div>
    <div class="form-row mt-3 mr-5 mb-3" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 5"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <membership-index @id="setId" @user="userProfile" :active="{ active }"></membership-index>
    </el-form>
    <el-form v-if="active === 2">
      <membership-historyreport :id="id" @invoiceId="invoiceid" :active="{ active }"></membership-historyreport>
    </el-form>
    <el-form v-if="active === 3">
      <invoice-view :id="invoice_id"></invoice-view>
    </el-form>
    <el-form v-if="active === 4">
      <my-profile :id="user_id" :remove="classRemove"></my-profile>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "DatatableWithFilter",
  data() {
    return {
      classRemove: true,
      active: 1,
      id: 0,
      invoice_id: 0,
      user_id:0,
    };
  },
  methods: {
    setId(id) {
      this.active = 2;
      this.id = id;
    },
    invoiceid(id) {
      this.active = 3;
      this.invoice_id = id;
    },
    userProfile(id) {
      this.active = 4;
      this.user_id = id;
    },
    previous() {
      if (this.active == 4) {
        this.active = 1;
      }
      else {
        if (this.active-- < 4) this.active = this.active--;
      }
    },
  },
};
</script>
